import { TAP_LIMIT } from '../../../constants/AppConstants';
import Item, { SHIFT_UP_DESKTOP, SHIFT_UP_MOBILE } from './Item';
import { SIZE_GROUND } from './Item';

export default class Stack extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });
    this.loadTexture('empty');

    this.items = [];
    this.stackType = '';

    // remove are abutton
    this.area.destroy();
    this.area = null;
  }

  init(itemData) {
    // add initial items
    if (itemData && itemData.items) {
      for (let i = 0; i < itemData.items.length; i++) {
        const item = this.location.addItem(itemData.items[i]);
        this.addItem(item, false);
      }
    }
    if (itemData) {
      this.setStackType(itemData.stack_type);
    }

    super.init(itemData);
  }

  get height() {
    if (this.bb) return this.bb.height;
    return 0;
  }

  setStackType(stackType) {
    this.stackType = stackType;
    if (stackType === 'food') {
      this.flags.push('ant');
    }
  }

  isFull() {
    return this.items.length === 6;
  }

  addItem(item, save = true) {
    item.disable();
    this.addChild(item);

    const lastItem = this.items.length > 0 ? this.items[this.items.length - 1] : null;

    item.x = 0;
    item.y = lastItem ? lastItem.y - lastItem.data.stackHeight : 0;
    item.setScale(1);

    item.stack = this; // set reference to this stack
    this.items.push(item);

    // rmove from top
    if (item.parentObj) {
      item.parentObj.removeObject(item);
      item.parentObj = null;
    }

    this.updateBounds();

    save && this.onChange.dispatch();
  }

  updateBounds() {
    const lastItem = this.items[this.items.length - 1];
    const sh = lastItem ? (-lastItem.y + lastItem.height) * SIZE_GROUND : 16;
    this.bb = this.getBounds();
    this.bb.y -= sh - 8;
    this.bb.height = sh;
  }

  breakStack() {
    if (!this.broken) {
      this.broken = true;
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        item.enable();
        item.setScale(SIZE_GROUND);
        // item.x = this.x + Phaser.Math.between(-4, 4);
        // item.y = this.y + item.y;
        item.x = this.worldPosition.x - this.location.x + Phaser.Math.between(-4, 4);
        item.y = this.worldPosition.y + item.y;
        item.stack = null;
        this.location.addObjectToLocation(item);
        //
        if (!this.location.tryPutIntoPond(item)) {
          this.location.setDestinationPosition(item);
        }
      }
      this.items = null;
      this.location.removeItem(this);
    }
  }

  handleInputUp() {
    this.location.stopDragItem(this);
    this.drag = false;
    this.updateBounds();

    this.scale.set(SIZE_GROUND);

    // check if it was moved
    const dx = this.pointer.x - this.startPos.x;
    const dy = this.pointer.y - this.startPos.y;
    const dist = dx * dx + dy * dy;

    this.pointer = null;

    if (dist < TAP_LIMIT) {
      // fix position
      const dy =
        this.game.deviceMetric.platform.type === 'desktop' ? SHIFT_UP_DESKTOP : SHIFT_UP_MOBILE;
      this.y -= dy;

      this.breakStack();
    } else {
      // drop item
      this.onDrop.dispatch(this);
    }
  }

  handleTap() {
    this.breakStack();
  }

  canHover() {
    return !this.drag;
  }

  //
  serialize() {
    const data = super.serialize();
    data.open = this.isOpen;
    data.items = [];
    for (let i = 0; i < this.items.length; i++) {
      data.items.push(this.items[i].id);
    }
    data.stack_type = this.stackType;
    return data;
  }
}
